import React, { useState } from 'react';

const STATUS_COLORS = {
  'Proposal':  { bg: 'rgba(229,192,75,0.1)',  color: '#E5C04B' },
  'Active':    { bg: 'rgba(57,255,20,0.1)',   color: '#39FF14' },
  'On Hold':   { bg: 'rgba(229,192,75,0.1)',  color: '#E5C04B' },
  'Completed': { bg: 'rgba(83,145,255,0.1)',  color: '#5391FF' },
  'Archived':  { bg: 'rgba(86,86,86,0.2)',    color: '#565656' },
};

function StatusBadge({ status }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS['Active'];
  return (
    <span
      style={{
        backgroundColor: c.bg,
        color: c.color,
        border: `1px solid ${c.color}`,
        borderRadius: '10px',
        padding: '2px 8px',
        fontSize: '11px',
        fontWeight: 500,
        fontFamily: "'Roboto', sans-serif",
        whiteSpace: 'nowrap',
      }}
    >
      {status}
    </span>
  );
}

function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function ProjectList({ projects, selectedId, onSelect, onAdd }) {
  const [search, setSearch] = useState('');

  const filtered = projects.filter((p) =>
    p.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        width: '320px',
        minWidth: '320px',
        height: '100%',
        borderRight: '1px solid #333333',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#1e1e1e',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid #333333',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '12px',
          }}
        >
          <span
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 600,
              fontSize: '13px',
              color: '#888888',
              letterSpacing: '2px',
            }}
          >
            PROJECTS
          </span>
          <button
            onClick={onAdd}
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #39FF14',
              color: '#39FF14',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 500,
              fontSize: '12px',
              padding: '4px 10px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            +
          </button>
        </div>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search projects..."
          style={{
            width: '100%',
            backgroundColor: '#2a2a2a',
            border: '1px solid #333333',
            borderRadius: '4px',
            color: '#F5F5F5',
            fontFamily: "'Roboto', sans-serif",
            fontSize: '13px',
            padding: '7px 10px',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {filtered.length === 0 && (
          <div
            style={{
              padding: '24px 16px',
              fontFamily: "'Roboto', sans-serif",
              fontSize: '13px',
              color: '#565656',
              textAlign: 'center',
            }}
          >
            No projects found
          </div>
        )}
        {filtered.map((project) => {
          const isSelected = project._id === selectedId;
          return (
            <div
              key={project._id}
              onClick={() => onSelect(project)}
              style={{
                padding: '12px 16px',
                borderBottom: '1px solid #2a2a2a',
                cursor: 'pointer',
                backgroundColor: isSelected ? 'rgba(57,255,20,0.06)' : 'transparent',
                borderLeft: isSelected ? '3px solid #39FF14' : '3px solid transparent',
                transition: 'all 0.15s ease',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '4px',
                  gap: '8px',
                }}
              >
                <span
                  style={{
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: 500,
                    fontSize: '14px',
                    color: isSelected ? '#39FF14' : '#F5F5F5',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                  }}
                >
                  {project.title}
                </span>
                <StatusBadge status={project.status || 'Active'} />
              </div>
              {(project.start_date || project.end_date) && (
                <div
                  style={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: '12px',
                    color: '#565656',
                  }}
                >
                  {formatDate(project.start_date)}
                  {project.start_date && project.end_date ? ' — ' : ''}
                  {formatDate(project.end_date)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
